import { useQuery } from "@tanstack/react-query";

import { adsService } from "../services/adsService";
import type { PostPerformanceResponse } from "../types";

export const postPerformanceKeys = {
  detail: (postId: string, window: number) =>
    ["post-performance", postId, window] as const,
};

export function usePostPerformance(
  postId: string | null,
  windowDays = 30,
  { enabled = true }: { enabled?: boolean } = {},
) {
  return useQuery<PostPerformanceResponse>({
    queryKey: postId
      ? postPerformanceKeys.detail(postId, windowDays)
      : ["post-performance", "none"],
    queryFn: () => adsService.getPostPerformance(postId!, windowDays),
    enabled: enabled && !!postId,
    staleTime: 60_000,
  });
}
